import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-41159374"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ml40 mt20"
};
const _hoisted_2 = {
  class: "tabs flex_FSC"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "section mt15"
};
const _hoisted_5 = {
  class: "flex_size_1"
};
const _hoisted_6 = {
  class: "flex_size_1"
};
const _hoisted_7 = {
  class: "flex_size_1"
};
const _hoisted_8 = {
  class: "flex_size_1"
};
const _hoisted_9 = {
  class: "_table mt20"
};
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"_table_items flex_FSBC\" data-v-41159374><p class=\"_table_label\" data-v-41159374>运单号</p><p class=\"_table_label\" data-v-41159374>装货地</p><p class=\"_table_label\" data-v-41159374>卸货地</p><p class=\"_table_label\" data-v-41159374>货物</p><p class=\"_table_label\" data-v-41159374>数量</p><p class=\"_table_label\" data-v-41159374>单位</p><p class=\"_table_label\" data-v-41159374>价格</p><p class=\"_table_label\" data-v-41159374>承运人</p><p class=\"_table_label\" data-v-41159374>联系号码</p><p class=\"_table_label\" data-v-41159374>车辆信息</p><p class=\"_table_label\" data-v-41159374>状态</p><p class=\"_table_label\" data-v-41159374>开票</p><p class=\"_table_label\" style=\"flex:3;\" data-v-41159374>操作</p></div>", 1);
const _hoisted_11 = {
  class: "flex_FSBC _table_items_desc pb15"
};
const _hoisted_12 = {
  class: "mr15"
};
const _hoisted_13 = {
  class: "flex_FSBC mt10"
};
const _hoisted_14 = {
  class: "_table_label ellipsis"
};
const _hoisted_15 = {
  class: "_table_label ellipsis"
};
const _hoisted_16 = {
  class: "_table_label ellipsis"
};
const _hoisted_17 = {
  class: "_table_label ellipsis"
};
const _hoisted_18 = {
  class: "_table_label ellipsis"
};
const _hoisted_19 = {
  class: "_table_label ellipsis"
};
const _hoisted_20 = {
  class: "_table_label ellipsis"
};
const _hoisted_21 = {
  class: "_table_label ellipsis"
};
const _hoisted_22 = {
  class: "_table_label ellipsis"
};
const _hoisted_23 = {
  class: "_table_label ellipsis"
};
const _hoisted_24 = {
  class: "_table_label ellipsis"
};
const _hoisted_25 = {
  class: "_table_label ellipsis"
};
const _hoisted_26 = {
  class: "_table_label flex_FSC",
  style: {
    "flex": "3"
  }
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  key: 0,
  class: "btn"
};
const _hoisted_30 = {
  key: 0,
  class: "btn"
};
const _hoisted_31 = {
  key: 0,
  class: "btn"
};
const _hoisted_32 = ["disabled", "onClick"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  key: 3,
  class: "btn pointer_default",
  disabled: ""
};
const _hoisted_35 = {
  key: 4,
  class: "btn pointer_default",
  disabled: ""
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = ["onClick"];
const _hoisted_38 = {
  class: "flex_FCAC"
};
const _hoisted_39 = {
  class: "flex_FEC"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_popconfirm = _resolveComponent("el-popconfirm");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.tabs, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['tabs_item mr20 pointer', $setup.data.tabsIndex == item.value && 'active']),
      key: index,
      onClick: () => $setup.setTabsIndex(item.value)
    }, _toDisplayString(item.label), 11, _hoisted_3);
  }), 128))]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
    class: "flex_FSBS"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form_item, {
      label: "货源单号"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        clearable: "",
        modelValue: $setup.data.demandNo,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.data.demandNo = $event),
        placeholder: "请输入货源单号",
        style: {
          "width": "10vw"
        },
        onKeydown: _withKeys($setup.search, ["enter"])
      }, null, 8, ["modelValue", "onKeydown"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "卸货地ㅤ"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_cascader, {
        clearable: "",
        style: {
          "width": "10vw"
        },
        modelValue: $setup.data.unloadingAddress,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.data.unloadingAddress = $event),
        options: $setup.city,
        props: $setup.data.cascaderProps,
        separator: ">",
        placeholder: "请选择卸货地"
      }, null, 8, ["modelValue", "options", "props"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_form_item, {
      label: "运单号"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        clearable: "",
        modelValue: $setup.data.orderNo,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.data.orderNo = $event),
        style: {
          "width": "10vw"
        },
        placeholder: "请输入运单号",
        onKeydown: _withKeys($setup.search, ["enter"])
      }, null, 8, ["modelValue", "onKeydown"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "装货地"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_cascader, {
        clearable: "",
        modelValue: $setup.data.loadingAddress,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.data.loadingAddress = $event),
        options: $setup.city,
        props: $setup.data.cascaderProps,
        style: {
          "width": "10vw"
        },
        separator: ">",
        placeholder: "请选择装货地"
      }, null, 8, ["modelValue", "options", "props"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_form_item, {
      label: "司机姓名"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        clearable: "",
        modelValue: $setup.data.driverName,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.data.driverName = $event),
        style: {
          "width": "10vw"
        },
        placeholder: "请输入司机姓名",
        onKeydown: _withKeys($setup.search, ["enter"])
      }, null, 8, ["modelValue", "onKeydown"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "司机手机"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        clearable: "",
        modelValue: $setup.data.driverPhone,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.data.driverPhone = $event),
        style: {
          "width": "10vw"
        },
        placeholder: "请输入司机手机",
        onKeydown: _withKeys($setup.search, ["enter"])
      }, null, 8, ["modelValue", "onKeydown"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_form_item, {
      label: "发货时间",
      class: "mr10"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_config_provider, {
        locale: $setup.zhCn
      }, {
        default: _withCtx(() => [_createVNode(_component_el_date_picker, {
          modelValue: $setup.data.times,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.data.times = $event),
          type: "daterange",
          "range-separator": "至",
          "start-placeholder": "开始时间",
          style: {
            "width": "10vw"
          },
          "end-placeholder": "结束时间"
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["locale"])]),
      _: 1
    }), _createElementVNode("div", null, [_createVNode(_component_el_button, {
      class: "mr10",
      type: "primary",
      onClick: $setup.search
    }, {
      default: _withCtx(() => [_createTextVNode("查询")]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      onClick: $setup.reset
    }, {
      default: _withCtx(() => [_createTextVNode("重置")]),
      _: 1
    }, 8, ["onClick"])])])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_9, [_hoisted_10, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.list, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "_table_items mt20",
      key: item.orderNo
    }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_12, "创建时间：" + _toDisplayString($setup.moment(item.createTime).format("YYYY-MM-DD")), 1), _createElementVNode("span", null, "货源单号：" + _toDisplayString(item.demandNo), 1)]), _createElementVNode("div", null, " 详细地址：" + _toDisplayString(item.loadingAddress) + " → " + _toDisplayString(item.unloadingAddress), 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("p", _hoisted_14, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: item.orderNo,
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.orderNo), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("p", _hoisted_15, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: item.loadingCity,
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.loadingCity), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("p", _hoisted_16, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: item.unloadingCity,
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.unloadingCity), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("p", _hoisted_17, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: item.goodsName,
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.goodsName), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("p", _hoisted_18, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: item.weight / 100,
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.weight / 100), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("p", _hoisted_19, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: $setup.freightUnitTypeMap[item.unitType].text,
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.freightUnitTypeMap[item.unitType].text), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("p", _hoisted_20, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: `${item.amount / 100} 元/
          ${$setup.freightUnitTypeMap[item.unitType].text}
        `,
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.amount / 100) + "元/" + _toDisplayString($setup.freightUnitTypeMap[item.unitType].text), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("p", _hoisted_21, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: item.driverName,
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.driverName), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("p", _hoisted_22, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: $setup.phoneDesc(item.driverPhone),
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.phoneDesc(item.driverPhone)), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("p", _hoisted_23, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: item.vehicleNo,
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.vehicleNo), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("p", _hoisted_24, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: $setup.orderStatusList[item.status],
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.forwarderInvoice == 1 && item.driverInvoice == 2 ? "待评价" : $setup.orderStatusList[item.status]), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("p", _hoisted_25, [_createVNode(_component_el_tooltip, {
      effect: "dark",
      content: `${item.invoiceStatus == -1 ? '未申请' : $setup.invoiceSuccessList[item.invoiceStatus]}`,
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.invoiceStatus == -1 ? "未申请" : $setup.invoiceSuccessList[item.invoiceStatus]), 1)]),
      _: 2
    }, 1032, ["content"])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", {
      class: "btn",
      onClick: () => $setup.toOrderDeatil(item.orderId)
    }, " 查看 ", 8, _hoisted_27), [0, 1, 2, 3, 4, 5, 9].includes(item.status) ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "btn",
      onClick: () => $setup.contact(item.driverPhone)
    }, " 联系承运人 ", 8, _hoisted_28)) : _createCommentVNode("", true), _createVNode(_component_el_popconfirm, {
      title: "同意取消该订单吗?",
      "confirm-button-text": "确定",
      "cancel-button-text": "取消",
      onConfirm: () => $setup.agreeCancelOrder(item.orderId, 1)
    }, {
      reference: _withCtx(() => [[5].includes(item.status) ? (_openBlock(), _createElementBlock("div", _hoisted_29, "同意取消")) : _createCommentVNode("", true)]),
      _: 2
    }, 1032, ["onConfirm"]), _createVNode(_component_el_popconfirm, {
      title: "拒绝取消该订单吗?",
      "confirm-button-text": "确定",
      "cancel-button-text": "取消",
      onConfirm: () => $setup.agreeCancelOrder(item.orderId, 0)
    }, {
      reference: _withCtx(() => [[5].includes(item.status) ? (_openBlock(), _createElementBlock("div", _hoisted_30, "拒绝取消")) : _createCommentVNode("", true)]),
      _: 2
    }, 1032, ["onConfirm"]), _createVNode(_component_el_popconfirm, {
      title: "确定取消订单?",
      "confirm-button-text": "确定",
      "cancel-button-text": "取消",
      onConfirm: () => _ctx.cancelOrder(item.orderId)
    }, {
      reference: _withCtx(() => [[0, 1].includes(item.status) ? (_openBlock(), _createElementBlock("div", _hoisted_31, " 取消订单 ")) : _createCommentVNode("", true)]),
      _: 2
    }, 1032, ["onConfirm"]), item.status == 0 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "btn",
      disabled: item.isSign,
      onClick: () => $setup.sign(item)
    }, _toDisplayString(item.isSign ? "已签约" : "我要签约"), 9, _hoisted_32)) : _createCommentVNode("", true), item.status == 9 && !item.forwarderInvoice && !item.driverInvoice && item.hasInvoice ? (_openBlock(), _createElementBlock("div", {
      key: 2,
      class: "btn",
      onClick: () => $setup.invoice(item)
    }, " 确认结算 ", 8, _hoisted_33)) : _createCommentVNode("", true), item.status == 9 && item.forwarderInvoice == 1 && !item.driverInvoice ? (_openBlock(), _createElementBlock("div", _hoisted_34, " 待确认开票 ")) : _createCommentVNode("", true), item.status == 9 && item.forwarderInvoice == 1 && item.driverInvoice == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_35, " 已开票 ")) : _createCommentVNode("", true), (item.status == 9 || item.status == 10) && !item.isEvaluation ? (_openBlock(), _createElementBlock("div", {
      key: 5,
      class: "btn",
      onClick: () => $setup.toEvaluate(item)
    }, " 去评价 ", 8, _hoisted_36)) : _createCommentVNode("", true), (item.status == 9 || item.status == 10) && item.isEvaluation ? (_openBlock(), _createElementBlock("div", {
      key: 6,
      class: "btn",
      onClick: () => $setup.viewProfile(item.driverId)
    }, " 查看评价 ", 8, _hoisted_37)) : _createCommentVNode("", true)])])]);
  }), 128))]), _createElementVNode("div", _hoisted_38, [_createVNode(_component_el_config_provider, {
    locale: $setup.zhCn
  }, {
    default: _withCtx(() => [_createVNode(_component_el_pagination, {
      "page-size": $setup.data.size,
      class: "mt20",
      background: "",
      layout: "pager,total",
      total: $setup.data.total,
      onCurrentChange: $setup.currentChange
    }, null, 8, ["page-size", "total", "onCurrentChange"])]),
    _: 1
  }, 8, ["locale"])])]), _createVNode(_component_el_dialog, {
    style: {
      "width": "60vw",
      "height": "95vh",
      "overflow": "hidden",
      "overflow-y": "auto"
    },
    top: "2.5vh",
    center: "",
    modelValue: $setup.dialog.visible,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $setup.dialog.visible = $event),
    "show-close": false
  }, {
    header: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[7] || (_cache[7] = () => $setup.handleContractSign())
    }, {
      default: _withCtx(() => [_createTextVNode(" 签约 ")]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_image, {
      src: 'data:image/png;base64,' + $setup.dialog.contractInfo.contract,
      fit: "contain"
    }, null, 8, ["src"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}